// src/services/studentService.ts
import { getRequest } from "./api.service";
import { API_URL } from "../utils/constants";
import { ICommon } from "../pages/reviews/types";

export interface IStudentDetail {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  gender: string;
  countryOfOrigin: string;
  countryOfResidence: string;
  email: string;
  languagesSpoke: string[];
  Interests: string[];
  profilePictureUrl: string;
}

export interface StudentResponse extends ICommon {
  result: IStudentDetail;
}

export interface Student {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  dateCreated: string;
}

export const fetchStudents = async (
  offset: number,
  limit: number,
  page: number
): Promise<Student[]> => {
  const data = await getRequest<{ result: { users: Student[] } }>(
    `${API_URL}/users/all?offset=${offset}&limit=${limit}&page=${page}`
  );
  return data.result.users;
};

export const studentDetails = async (
  userId: string
): Promise<StudentResponse> => {
  const data = await getRequest<StudentResponse>(
    `${API_URL}/users/details/${userId}`
  );
  return data;
};
